function AddInventoryPanelCtrl($scope, $panelInstance, venue, date, inventory, type, enable,
  schedule, day, dateUtilsService, onAddedOrUpdated) { //eslint-disable-line
  $scope.day = day;
  $scope.venue = venue;
  $scope.currentDate = date;
  $scope.date = dateUtilsService.toUTCTimestampWithoutTime(date);
  $scope.schedule = schedule;
  $scope.enable = enable;
  $scope.inventory = inventory;
  $scope.type = type;
  $scope.onAddedOrUpdated = function(result) {
    $panelInstance.close(false);

    onAddedOrUpdated(result);
  };
  $scope.close = function() {
    $panelInstance.close(false);
  };
}

AddInventoryPanelCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'venue',
  'date',
  'inventory',
  'type',
  'enable',
  'schedule',
  'day',
  'dateUtilsService',
  'onAddedOrUpdated'
];

export default AddInventoryPanelCtrl;



// WEBPACK FOOTER //
// ./src/panels/addInventory/controller.js